const NewsLayout = (props) => {
  return (
    <section className='project-layout-container'>{props.children}</section>
  )
}

export default NewsLayout
